import { useRef, useState, useEffect } from 'react';
import { IonModal, IonButton, IonIcon, IonImg, IonGrid, IonRow, IonCol, useIonToast } from '@ionic/react';
import { close, trashOutline } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { ShowSwal } from '../../../defines/Functions';
import Swal from 'sweetalert2';
import axios from 'axios';
import Loading from '../../Loading';
import TravelerForm from './forms/TravelerForm';
import './ProfileTravelers.css';
import travelers from '../../../assets/images/dashboard-passengers.svg';
import trash from '../../../assets/images/trash.svg';
import warningSign from '../../../assets/images/warning.svg';

const ProfileTravelers = () => {
    const profileTravelers = Constants.api.profileTravelers;
    const profileTravelerRemove = Constants.api.profileTravelerRemove;
    const [present] = useIonToast();
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    };
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showProfileTravelersModal: false,
        token: '',
        travelers: [] as any,
        formType: 'add'
    });
    const userDataRef = useRef(false);
    const getUserData = async () => {
        if (!userDataRef.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setState({ ...state, token: objectValue.token });
            } else {
                return false;
            }
        }
        userDataRef.current = true;
    }
    getUserData();
    const didGetTravelers = useRef(false);
    const getTravelers = async () => {
        setLoading(true);
        try {
            const travelersResults = await axios.get(profileTravelers, {
                headers: {
                    Authorization: 'Bearer ' + state.token
                }
            });
            if (travelersResults.status === 200) {
                setState(prevState => ({ ...prevState, travelers: travelersResults.data.items }));
                setLoading(false);
            }
        } catch (error: any) {
            console.log(error);
        }

    }
    useEffect(() => {
        if (state.showProfileTravelersModal) {
            getTravelers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showProfileTravelersModal]);
    const removeTraveler = (id: number) => {
        const swalOptions = {
            text: 'آیا از حذف این مسافر اطمینان دارید؟',
            iconHtml: '<img src="' + trash + '" width="70" />',
            customClass: {
                container: ''
            },
            backdrop: true,
            allowOutsideClick: true,
            showConfirmButton: true,
            confirmButtonText: 'بله',
            confirmButtonColor: '#333D79',
            showDenyButton: true,
            denyButtonText: 'خیر',
            denyButtonColor: '#F1C400',
            isConfirmed: () => confirmRemove(id),
            isDenied: () => Swal.close()
        }
        ShowSwal(swalOptions);
        const confirmRemove = async (id: number) => {
            setLoading(true);
            try {
                const removeResults = await axios.get(profileTravelerRemove + id, {
                    headers: {
                        Authorization: 'Bearer ' + state.token
                    }
                });
                if (removeResults.data.result === 'error') {
                    showToast({ message: removeResults.data.message, color: 'danger' });
                    setLoading(false);
                } else {
                    showToast({ message: removeResults.data.message, color: 'success' });
                    setLoading(false);
                    didGetTravelers.current = false;
                    getTravelers();
                }
            } catch (error: any) {
                console.log(error);
            }
        }
    }
    const handleSubmitCallback = (childData: boolean) => {
        if (childData) {
            didGetTravelers.current = false;
            getTravelers();
        }
    }
    return (
        <>
            <IonModal isOpen={state.showProfileTravelersModal} onDidDismiss={() => setState({ ...state, showProfileTravelersModal: false })} mode="ios" cssClass="profile-travelers-modal">
                <div className="profile-travelers-modal-content">
                    <h3 className="profile-travelers-modal-title">
                        لیست مسافرین
                        <IonIcon icon={close} onClick={() => setState({ ...state, showProfileTravelersModal: false })} />
                    </h3>
                    <TravelerForm formType="add" data={null} submitParentCallback={handleSubmitCallback} />
                    <div className="profile-travelers-modal-items">
                        {!loading ?
                            <IonGrid>
                                {state.travelers.length === 0 ?
                                    <div className="box-error">
                                        <IonImg src={warningSign} />
                                        <p>در حال حاضر هیچ مسافری ثبت نشده است</p>
                                    </div>
                                    :
                                    <>
                                        <IonRow>
                                            <IonCol size="3">
                                                نام مسافر
                                            </IonCol>
                                            <IonCol size="2">
                                                ملیت
                                            </IonCol>
                                            <IonCol size="3">
                                                تاریخ تولد
                                            </IonCol>
                                            <IonCol size="4">
                                                عملیات
                                            </IonCol>
                                        </IonRow>
                                        {state.travelers.map((item: any, index: number) =>
                                            <IonRow key={"index" + index}>
                                                <IonCol size="3">
                                                    {item.first_name_en + ' ' + item.last_name_en}
                                                </IonCol>
                                                <IonCol size="2">
                                                    {item.nationality}
                                                </IonCol>
                                                <IonCol size="3">
                                                    {item.birth_date}
                                                </IonCol>
                                                <IonCol size="4" className="action-btns">
                                                    <TravelerForm formType="edit" data={item} submitParentCallback={handleSubmitCallback} />
                                                    <IonButton color="danger" onClick={() => removeTraveler(item.id)}>
                                                        <IonIcon icon={trashOutline} />
                                                    </IonButton>
                                                </IonCol>
                                            </IonRow>
                                        )}
                                    </>
                                }
                            </IonGrid>
                            :
                            <Loading />
                        }
                    </div>
                </div>
            </IonModal>
            <div className="dashboard-box" onClick={() => setState({ ...state, showProfileTravelersModal: true })}>
                <div>
                    <IonImg src={travelers} />
                </div>
                <div>
                    <b>لیست مسافرین</b>
                </div>
            </div>
        </>
    );
};
export default ProfileTravelers;